import { createContext, useContext, useState, useEffect } from 'react';
import { getMe } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
      // Verify token is still valid
      getMe()
        .then((res) => {
          setUser(res.data);
          localStorage.setItem('user', JSON.stringify(res.data));
        })
        .catch(() => {
          logout();
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  const isMunicipalAdmin = () => user?.role === 'municipal_admin';
  const isBarangayAdmin = () => user?.role === 'barangay_admin';
  const isBHW = () => user?.role === 'bhw';
  const isEMT = () => user?.role === 'emt';
  const canManageBarangay = () => ['municipal_admin', 'barangay_admin'].includes(user?.role);

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      login,
      logout,
      isMunicipalAdmin,
      isBarangayAdmin,
      isBHW,
      isEMT,
      canManageBarangay,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
